import { Search } from 'lucide-react'
import { Input } from '@/components/ui/input'

interface SearchInputProps {
	value: string
	onChange: (value: string) => void
	autoFocus?: boolean
}

export function SearchInput({ value, onChange, autoFocus }: SearchInputProps) {
	return (
		<Input
			variant='icon'
			icon={<Search />}
			type='search'
			value={value}
			autoFocus={autoFocus}
			placeholder='Enter game name or characters'
			onChange={(event) => onChange(event.target.value)}
			aria-label='Search games'
			containerClassName='min-w-0 flex-1'
		/>
	)
}
